<template>
  <div class="reference-slider" :class="{ 'reference-slider--vert': isVertical }">
    <div class="tag-slider-controls">
      <div class="tag-slider-prev">
        <fa :icon="['fal', 'chevron-left']"/>
      </div>
      <div class="tag-slider-next">
        <fa :icon="['fal', 'chevron-right']"/>
      </div>
    </div>
    <div class="reference-container">
      <tiny-slider 
        v-bind="isVertical ? verticalTinySliderOptions : tinySliderOptions"
        :startIndex="dir === 'rtl' ? tagRef.length - 1 : 0"
        ref="tinySlider"
      >
        <div v-for="(tag, index) in tagRef" :key="tag._id">
          <div class="slide" :class="{ 'slide--reverse' : dir === 'rtl' }">
            <div class="slide__image-wrapper" :class="tag.image === '' ? 'no-image' : null">
              <div v-show="!tag.hideTagReference" class="slide__image-reference">{{ tag.referenceIndex }}</div>
              <img 
                class="slide__image" 
                :class="tag.image === '' ? 'no-image' : null" 
                :src="`${$store.state.assetsPath}${tag.asset.customThumbPath ? tag.asset.customThumbPath : tag.asset.thumbPath}`" 
                alt=""
              >
            </div>
            <div class="slide__content" :class="{ 'dir-rtl' : dir === 'rtl' }">
              <div class="slide__heading" v-html="tag.label[lang]"></div>
              <div class="slide__description" v-html="tag.description[lang]"></div>
            </div>
          </div>
        </div> 
      </tiny-slider>
    </div>
  </div>
</template>
<script>
import TinySlider from 'vue-tiny-slider'

export default {
  
  name: 'reference-tag-slider',

  components: {
    TinySlider
  },

  props: {
    dir: String,
    lang: String,
    isVertical: Boolean,
    tagRef: Array
  },

  data() {
    return {
      tinySliderOptions: {
        axis: 'horizontal',
        mouseDrag: true,
        controlsContainer: '.tag-slider-controls',
        loop: false,
        items: 3,
        gutter: 0,
        nav: false,
        speed: 600,
        swipeAngle: 45
      },

      verticalTinySliderOptions: {
        axis: 'vertical',
        mouseDrag: true,
        controlsContainer: '.tag-slider-controls',
        loop: false,
        items: 2,
        gutter: 0,
        nav: false,
        speed: 600,
        swipeAngle: 45        
      }
    }
  }
}
</script>
<style lang="scss">
@import "node_modules/tiny-slider/src/tiny-slider";
@import "@/styles/_variables.scss";

.reference-slider {
  background: rgba(#000, .7);
  bottom: 0;
  color: #fff;
  font-family: $touchscreen-font;
  height: 23em;
  padding: 2.35em 8em 2.4em 9.8em;
  position: absolute;
  user-select: none;
  width: 100%;
  z-index: 5;

  .reference-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .tag-slider-controls {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 4em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .75em 0 1.25em;

    div {
      transition: opacity 0.3s;

      &[aria-disabled=true] {
        opacity: 0.2;
      }
    }
  }

  .slide {
    display: flex;
    height: 100%;
    padding: 0 2em;

    &--reverse {
      flex-direction: row-reverse;

      .slide__content {
        padding: 0 1em 0 0;
      }
    }

    &__image-wrapper, &__content {
      height: 18.5em;
      position: relative;
      width: 20em;

      &.no-image {
        background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
        background-position: 0px 0px, 10px 10px;
        background-size: 20px 20px;
      }
    }

    &__image-reference {
      background-color: #000;
      border-radius: 1.5em;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.5em;
      font-size: 1.5em;
      position: absolute;
      top: 0;
      left: 0;
      height: calc(3em * 10 / 15);
      width: calc(3em * 10 / 15);
    }

    &__content {
      padding-left: 1em;
    }

    &__image {
      height: 18.5em;
      object-fit: cover;
      width: 20em;

      &.no-image {
        opacity: 0 !important;
      }
    }

    &__heading {
      font-size: 1.5em;
      font-weight: 400;
      margin-bottom: 0.5em;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &__description {
      font-size: 1.5em;
      font-weight: 200;
      line-height: 1.2;
      letter-spacing: 0.05em;
    }
  }

  &--vert {
    right: 0;
    height: 100%;
    padding: 14em 4em 8em;
    width: 28em;

    .tag-slider-controls {
      bottom: 0;
      height: 2em;
      top: unset;
      padding: 0;
    }

    .tag-slider-prev, .tag-slider-next {
      padding: .5em 1.1em;
      transform: rotate(90deg);
    }

    .slide {
      display: block;
      padding: 0;
      height: 50%;

      &__image-wrapper, &__content {
        position: relative;
        width: 100%;
      }

      &__content {
        padding-bottom: 2em;
        padding-left: 0em;
      }

      &__image {
        height: 18.5em;
        object-fit: cover;
        width: 20em;
        padding-bottom: 1em;
      }

      &__heading {
        font-size: 1.5em;
        font-weight: 400;
        margin-bottom: 0.5em;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }

      &__description {
        font-size: 1.5em;
        font-weight: 200;
        line-height: 1.2;
        letter-spacing: 0.05em;
      }
    }
  }
}
</style>